var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#15B785"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4415 13.0375V13.036C13.359 13.042 12.9338 13.0675 11.985 13.0675C11.2275 13.0675 10.6943 13.045 10.5068 13.036V13.0383C7.59079 12.91 5.41429 12.4023 5.41429 11.7948C5.41429 11.188 7.59079 10.6803 10.5068 10.5498V12.5328C10.6973 12.5463 11.2433 12.5785 11.9978 12.5785C12.903 12.5785 13.3568 12.541 13.4415 12.5335V10.5513C16.3515 10.681 18.5228 11.1888 18.5228 11.7948C18.5228 12.4023 16.3515 12.9085 13.4415 13.0375V13.0375ZM13.4415 10.345V8.5705H17.502V5.8645H6.44629V8.5705H10.5068V10.3443C7.20679 10.4958 4.72504 11.1498 4.72504 11.9328C4.72504 12.7158 7.20679 13.369 10.5068 13.5213V19.2078H13.4415V13.5198C16.7363 13.3683 19.212 12.715 19.212 11.9328C19.212 11.1505 16.7363 10.4973 13.4415 10.345",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.6e62b2de3f2d3c23bc042e7b4486908f.svg";
export { ForwardRef as ReactComponent };